import { combineReducers } from "redux";
import { DateTime } from "../../Model";
import minimumDurationReducers from "../minimum-length-radio-selector/minimumDurationSlice";
import toTimesReducers from "reducers/toTimeReducer";
import fromTimesReducers from "reducers/fromTimeReducer";
import dayReducers from "reducers/daysReducer";
import useDayPartsReducers from "reducers/useDayPartsReducer";
import dayPartReducers from "reducers/dayPartReducer";
import fromDateReducers from "reducers/fromDateReducers";
import toDateReducers from "reducers/toDateReducer";

const dateTimeReducers = combineReducers<DateTime>( {
  fromDate: fromDateReducers,
  toDate: toDateReducers,
  useDayParts: useDayPartsReducers,
  days: dayReducers,
  minimumDuration: minimumDurationReducers,
  fromTime: fromTimesReducers,
  toTime: toTimesReducers,
  dayParts: dayPartReducers
} );

export default dateTimeReducers;
